export enum SiteDomain {
    USERAPP = 'userapp',
    ADMIN = 'admin',
    PARTNER = 'partner',
    SUPPORT = 'support',
}

export type PortalState = {
    currentDomain: null | SiteDomain
    isUserappDomain: boolean
    isAdminDomain: boolean
    isPartnerDomain: boolean
    isSupportDomain: boolean
    isPortalDomain: boolean
    currentPortalAudience: null | string
}

// Resolve the mounted portal from the first URL path segment.
export const resolveCurrentDomain = (pathname: string): null | SiteDomain => {
    const domain = (pathname.match(/^\/+([^/]+)(?:\/|$)/) || [])[1]

    switch (domain) {
        case SiteDomain.ADMIN:
            return SiteDomain.ADMIN
        case SiteDomain.PARTNER:
            return SiteDomain.PARTNER
        case SiteDomain.SUPPORT:
            return SiteDomain.SUPPORT
        case SiteDomain.USERAPP:
            return SiteDomain.USERAPP
        default:
            return null
    }
}

// Build the full portal flag set used across auth/session logic from a browser pathname.
export const getPortalState = (pathname: string): PortalState => {
    const currentDomain = resolveCurrentDomain(pathname)

    return {
        currentDomain,
        isUserappDomain: currentDomain === SiteDomain.USERAPP,
        isAdminDomain: currentDomain === SiteDomain.ADMIN,
        isPartnerDomain: currentDomain === SiteDomain.PARTNER,
        isSupportDomain: currentDomain === SiteDomain.SUPPORT,
        isPortalDomain: Boolean(currentDomain),
        currentPortalAudience: currentDomain,
    }
}
